import text from './resources/locale/en.json';

class AccessDenied {
    $onInit() {
        this.text = text;
    }
}

export default AccessDenied;
